import type { WithId } from '@medplum/core';
import type { Observation } from '@medplum/fhirtypes';
import { useTranslation } from 'react-i18next';
import { LabsSummary } from './LabsSummary';
import type { PromotionStatus } from './RecordListItem';

export type LabsListProps = {
  labs: WithId<Observation>[];
  onSelectLab?: (labIdentifier: string) => void;
  selectedLabIdentifier?: string;
  onPromotionClick?: (labIdentifier: string) => void;
  getPromotionStatus?: (labIdentifier: string) => PromotionStatus;
};

export const LabsList = ({
  labs,
  onSelectLab,
  selectedLabIdentifier,
  onPromotionClick,
  getPromotionStatus,
}: LabsListProps): React.ReactElement => {
  const { t } = useTranslation('records');

  return (
    <div className="mx-auto w-full max-w-4xl">
      {labs.length > 0 ? (
        <LabsSummary
          labs={labs}
          onSelectLab={onSelectLab}
          selectedLabIdentifier={selectedLabIdentifier}
          onPromotionClick={onPromotionClick}
          getPromotionStatus={getPromotionStatus}
        />
      ) : (
        <p className="py-8 text-center text-sm text-muted-foreground">{t('noLabResultsFound')}</p>
      )}
    </div>
  );
};
